module.exports = __webpack_public_path__ + "img/london.ca3d671e.png";